<template>
  <div class="sidebar">
    <!-- <p class="title-menu">Menu</p> -->
    <ul>
      <router-link to="/deposit" class="link">
        <li>
          <img src="@/assets/icons/deposit/1c.svg" class="icon-sidebar" />
          Deposit
        </li>
      </router-link>
      <router-link to="/witdrawal" class="link">
        <li>
          <img src="@/assets/icons/withdrawal/1c.svg" class="icon-sidebar" />
          Withdrawal
        </li>
      </router-link>
      <router-link to="/profil" class="link">
        <li>
          <b-icon icon="person-fill" class="icon-font"></b-icon>

          <!-- <img src="@/assets/icons/profile.svg" class="icon-sidebar" /> -->
          Profil
        </li>
      </router-link>
      <li @click="logout">
        <img src="@/assets/icons/5a.svg" class="icon-sidebar" />
        Logout
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
      dasboard: require("@/assets/iconImage/dashboard_active.png"),
      imgDashboard: require("@/assets/iconImage/Asset79.png"),
      iconLogout: require("@/assets/iconImage/logout_inactive.png"),
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.go("/home");
      });
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 219px;
}

.title-menu {
  padding: 30px 25px 15px;
  margin: 0;
  font-size: 14px;
}

ul {
  margin-top: 1rem;
}

ul li {
  list-style: none;
}

li {
  /* height: 60px; */
  /* border: solid 1px; */
  align-items: center;
  font-size: 14px;
  padding: 15px 25px;
  cursor: pointer;
  color: #707070;
}

a .router-link-exact-active,
.router-link-active li {
  background-color: rgba(230, 230, 230, 0.25);
  color: #6454f0;
  position: relative;
}

li:hover {
  background-color: rgba(230, 230, 230, 0.25);
  color: #6454f0;
}

a .router-link-exact-active,
.router-link-active li::before {
  content: "";
  width: 5px;
  height: 46px;
  background: #6454f0;
  position: absolute;
  left: 0px;
  margin-top: -12px;
}

.link:hover {
  text-decoration: none;
}

.icon-sidebar {
  width: 18px;
  margin-right: 10px;
  vertical-align: text-top;
}
.icon-font {
  font-size: 25px;
  margin-right: 10px;
  color: #6454f0;
  margin-left: -3px;
}

@media (max-width: 768px) {
  ul {
    margin-top: 2rem;
  }
}
</style>
